import { Component, input, OnInit, output } from '@angular/core';

import { Group, GroupService } from 'app/providers/semantria-api/group.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { SemantriaConfiguration } from '../../../../providers/semantria-api/configuration.service';
import { ConfigurationMoveEvent } from '../configuration-table/configuration-table.component';

export interface MoveConfigurationDialogOptions {
  configuration: SemantriaConfiguration;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-move-configuration-dialog',
  templateUrl: './move-configuration-dialog.component.html',
  styleUrls: ['./move-configuration-dialog.component.scss'],
  standalone: false,
})
export class MoveConfigurationDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly config = input<SemantriaConfiguration>();
  readonly modalClosed = output<ConfigurationMoveEvent>();

  selectedConfiguration: SemantriaConfiguration;
  originalGroup: Group;
  selectedGroup: Group;
  visibleGroups: Group[];

  constructor(private groupService: GroupService) {}

  ngOnInit() {
    this.selectedConfiguration = this.config();
    this.originalGroup = this.groupService.getSelectedGroup();
    this.selectedGroup = this.groupService.getSelectedGroup();
    this.visibleGroups = this.groupService.getVisibleGroups();
  }

  cancel() {
    this.modalClosed.emit(null);
  }

  move() {
    const permission = this.originalGroup.permissions.find(
      (perm) => perm.config_id && perm.config_id === this.selectedConfiguration.id
    );

    const response: ConfigurationMoveEvent = {
      originalGroupId: this.originalGroup.group_id,
      originalGroupName: this.originalGroup.group_name,
      newGroupId: this.selectedGroup.group_id,
      newGroupName: this.selectedGroup.group_name,
      oldPermissionId: permission.permission_id,
      newPermission: {
        permission_type: 'CONFIGURATION',
        group_id: this.selectedGroup.group_id,
        config_id: this.selectedConfiguration.id,
      },
    };
    this.modalClosed.emit(response);
  }

  onChangeGroup(group: Group) {
    this.selectedGroup = group;
  }
}
